import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/page-labels';
import { PageLabelsModule } from '@upr-web-primer/page-labels';
import * as i2 from '@upr-web-primer/url-info';
import { UrlInfoModule } from '@upr-web-primer/url-info';
import { WindowModule } from '@upr-web-primer/window';
import { get, find, includes } from 'lodash-es';

class MinisiteModule {
}
MinisiteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
MinisiteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteModule, imports: [WindowModule, PageLabelsModule, UrlInfoModule] });
MinisiteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteModule, imports: [[WindowModule, PageLabelsModule, UrlInfoModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [WindowModule, PageLabelsModule, UrlInfoModule]
                }]
        }] });

class MinisiteService {
    constructor(pageLabelsService, urlInfoService) {
        this.pageLabelsService = pageLabelsService;
        this.urlInfoService = urlInfoService;
        this.miniSites = [];
        this.pageLabelsService.get().then((pageLabels) => {
            this.pageLabels = pageLabels;
            this.miniSites = get(this.pageLabels, 'minisitesdirectorypattern', '').split(',');
        });
        this.urlInfoService.info$.subscribe(info => (this.urlInfo = info));
    }
    getUrl(url) {
        if (!this.urlInfo.path) {
            return url;
        }
        const minisite = find(this.miniSites, site => includes(this.urlInfo.path, '/' + site));
        if (!minisite) {
            return url;
        }
        if (!includes(url, minisite)) {
            const prefix = this.urlInfo.prefix || '';
            const minisiteUrl = (prefix +
                '/' +
                minisite +
                url.replace(prefix, '')).replace('//', '/');
            return minisiteUrl;
        }
        return url;
    }
}
MinisiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteService, deps: [{ token: i1.PageLabelsResolver }, { token: i2.UrlInfoService }], target: i0.ɵɵFactoryTarget.Injectable });
MinisiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: MinisiteService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.PageLabelsResolver }, { type: i2.UrlInfoService }]; } });

export { MinisiteModule, MinisiteService };
